module.exports = __webpack_public_path__ + "img/symbol_5.35185d2c.png";